export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.6.10-1025.03",
  commitId: "46ca8f9ec8a4548e9abbd3ca0a7f1b562dedf69b",
  commitTime: "2026-06-10T10:25:03.000Z",
});
